import axios from '../index';
import { PaginationResult, ResponseResult, Url } from "../Common/Util";

const GetUrl = Url("api/v1/Inventory/LaboratoryKit");

export default {
    Find,
    FindStock,
    GetById,
    Create
}
async function Find({ search, protocolId = null, pageSize = 10, pageNumber = 1, sortColumn, sortOrder }) {
    const response = await axios.get(GetUrl(), {
        params: { search, protocolId, pageSize, pageNumber, sortColumn, sortOrder }
    })
    return new PaginationResult({ ...response.data })
}
async function FindStock({ search, protocolId = null, pageSize = 10, pageNumber = 1, sortColumn, sortOrder }) {
    const response = await axios.get(GetUrl('/stock'), {
        params: { search, protocolId, pageSize, pageNumber, sortColumn, sortOrder }
    })
    return new PaginationResult({ ...response.data })
}
async function GetById(id) {
    const response = await axios.get(GetUrl(`/${id}`))
    return new ResponseResult({ ...response.data })
}
async function Create({ id, presentation }) {
    const response = await axios.post(GetUrl(''), { id, presentation })
    return new ResponseResult({ ...response.data })
}

